import React from 'react';
import { Square, Stack } from '@grubhubprod/gh-cookbook-react';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { PageTitle } from 'src/components/enterprise/layout/PageTitle/PageTitle';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import { EmployeeDetailsWrapper } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeDetailsWrapper/EmployeeDetailsWrapper';
import { buildCAUIPath, CAUIPage, getHomeBreadcrumb } from 'src/constants/urls';
import { EmployeeGroupsWrapper } from 'src/components/enterprise/features/Employee/EmployeeDetailsPage/components/EmployeeGroupsWrapper/EmployeeGroupsWrapper';

export const EmployeeDetailsPage: React.FC = () => {
  const { corpId } = useAuth();
  return (
    <Square inset="lg">
      <PageHeader>
        <PageTitle title="Employee Details" />
        <Breadcrumbs
          breadcrumbs={[
            {
              label: 'Admin home',
              ...getHomeBreadcrumb(corpId),
            },
            {
              label: 'Employees',
              href: buildCAUIPath(CAUIPage.EMPLOYEES, { corpId }),
            },
          ]}
        />
      </PageHeader>
      <Stack y="md">
        <EmployeeDetailsWrapper />
      </Stack>
      <EmployeeGroupsWrapper />
    </Square>
  );
};
